<div class="sticky-action-bar" [class.elevated]="isScrolled$ | async" [attr.data-screen-size]="screenSize$ | async">
  <!-- Ações de Template -->
  <div class="action-group templates">
    <button nz-button nzType="text" nzSize="small" (click)="onOpenTemplateManager()" [nz-tooltip]="'builderScreen.stickyActionBar.tooltip.manageTemplates' | translateTA">
      <nz-icon nzType="database"></nz-icon>
      <span class="action-text">{{ 'builderScreen.stickyActionBar.text.templates' | translateTA }}</span>
    </button>

    <button nz-button nzType="text" nzSize="small" nz-dropdown [nzDropdownMenu]="generatorMenu" nzTrigger="click" [nz-tooltip]="'builderScreen.stickyActionBar.tooltip.autoGenerators' | translateTA">
      <nz-icon nzType="robot"></nz-icon>
      <span class="action-text">{{ 'builderScreen.stickyActionBar.text.generate' | translateTA }}</span>
    </button>
    <nz-dropdown-menu #generatorMenu="nzDropdownMenu">
      <ul nz-menu>
        <li nz-menu-item (click)="onOpenAutoScreenGenerator()">
          <nz-icon nzType="robot" nzTheme="twotone"></nz-icon>
          {{ 'builderScreen.stickyActionBar.menu.generateAuto' | translateTA }}
        </li>
        <li nz-menu-item (click)="onOpenOptimizedAutoScreenGenerator()">
          <nz-icon nzType="thunderbolt" nzTheme="filled"></nz-icon>
          {{ 'builderScreen.stickyActionBar.menu.generateOptimized' | translateTA }}
        </li>
      </ul>
    </nz-dropdown-menu>

    <button nz-button nzType="primary" nzSize="small" (click)="onOpenSaveTemplateModal()" [nz-tooltip]="'builderScreen.stickyActionBar.tooltip.saveTemplate' | translateTA">
      <nz-icon nzType="save"></nz-icon>
      <span class="action-text">{{ 'builderScreen.stickyActionBar.text.save' | translateTA }}</span>
    </button>

    <button nz-button nzType="text" nzSize="small" 
            (click)="onOpenLauncherModal()" 
            [disabled]="!currentTemplateId"
            [nz-tooltip]="'builderScreen.stickyActionBar.tooltip.createLauncher' | translateTA">
      <nz-icon nzType="rocket" nzTheme="outline"></nz-icon>
      <span class="action-text">{{ 'builderScreen.stickyActionBar.text.launcher' | translateTA }}</span>
    </button>

    <nz-divider nzType="vertical"></nz-divider>
  </div>

  <!-- Ações Principais -->
  <div class="action-group primary">
    <!--button nz-button nzType="primary" [nzLoading]="isSaving$ | async" (click)="onSave()" [disabled]="isSaving$ | async">
      <nz-icon nzType="save" nzTheme="outline"></nz-icon>
      <span class="action-text">{{ 'builderScreen.actions.save' |translateTA }}</span>
    </button-->

    <!--button nz-button nzType="default" (click)="onCancel()" [disabled]="isSaving$ | async">
      <nz-icon nzType="close" nzTheme="outline"></nz-icon>
      <span class="action-text">{{ 'builderScreen.actions.cancel' |translateTA }}</span>
    </button-->

    <!-- Indicador de Mudanças Não Salvas -->
    <nz-tag *ngIf="hasUnsavedChanges$ | async" nzColor="orange" class="unsaved-indicator">
      <nz-icon nzType="edit" nzTheme="outline"></nz-icon>
      <span class="indicator-text">{{ 'builderScreen.status.unsavedChanges' |translateTA }}</span>
    </nz-tag>
  </div>

  <!-- Ações Secundárias -->
  <div class="action-group secondary">
    <!-- TEMPORARIAMENTE OCULTO - Desfazer/Refazer
    <nz-button-group>
      <button nz-button nzType="text" nz-tooltip="{{ 'builderScreen.actions.undo' |translateTA }}" (click)="onUndo()" [disabled]="!(canUndo$ | async)">
        <nz-icon nzType="undo" nzTheme="outline"></nz-icon>
      </button>
      <button nz-button nzType="text" nz-tooltip="{{ 'builderScreen.actions.redo' |translateTA }}" (click)="onRedo()" [disabled]="!(canRedo$ | async)">
        <nz-icon nzType="redo" nzTheme="outline"></nz-icon>
      </button>
    </nz-button-group>

    <nz-divider nzType="vertical"></nz-divider>
    -->

    <!-- Controles de Visualização -->
    <!--nz-button-group-->
      <button nz-button nzType="text" nz-tooltip="{{ 'builderScreen.actions.togglePreview' |translateTA }}" (click)="onTogglePreview()" [class.active]="isPreviewMode()">
        <nz-icon nzType="eye" nzTheme="outline"></nz-icon>
      </button>
      <button nz-button nzType="text" nz-tooltip="{{ 'builderScreen.actions.toggleGrid' |translateTA }}" (click)="onToggleGrid()" [class.active]="isGridVisible()">
        <nz-icon nzType="border" nzTheme="outline"></nz-icon>
      </button>
    <!--/nz-button-group-->

    <nz-divider nzType="vertical"></nz-divider>

    <!-- TEMPORARIAMENTE OCULTO - Funcionalidades Avançadas
    <nz-button-group>
      <button nz-button nzType="text" [nz-tooltip]="'builderScreen.actions.toggleFloatingInspector' |translateTA" (click)="onToggleFloatingInspector()" [class.active]="isFloatingInspectorActive()">
        <nz-icon nzType="control" nzTheme="outline"></nz-icon>
      </button>
      <button nz-button nzType="text" [nz-tooltip]="'builderScreen.actions.showPresets' |translateTA" (click)="onShowPresets()">
        <nz-icon nzType="star" nzTheme="outline"></nz-icon>
      </button>
      <button nz-button nzType="text" [nz-tooltip]="'builderScreen.actions.showAISuggestions' |translateTA" (click)="onShowAISuggestions()">
        <nz-icon nzType="bulb" nzTheme="outline"></nz-icon>
      </button>
      <button nz-button nzType="text" [nz-tooltip]="'builderScreen.actions.showTemplates' |translateTA" (click)="onShowTemplates()">
        <nz-icon nzType="appstore" nzTheme="outline"></nz-icon>
      </button>
      <button nz-button nzType="text" nz-dropdown [nzDropdownMenu]="inspectorModeMenu" nzTrigger="click" [nz-tooltip]="'builderScreen.actions.inspectorMode' |translateTA">
        <nz-icon nzType="layout" nzTheme="outline"></nz-icon>
      </button>
    </nz-button-group>
    
    <nz-dropdown-menu #inspectorModeMenu="nzDropdownMenu">
      <div nz-menu class="inspector-mode-dropdown">
        <app-inspector-mode-toggle></app-inspector-mode-toggle>
      </div>
    </nz-dropdown-menu>

    <nz-divider nzType="vertical"></nz-divider>
    -->

    <!-- Controles de Zoom -->
    <div class="zoom-controls">
      <button nz-button nzType="text" nzSize="small" nz-tooltip="{{ 'builderScreen.actions.zoomOut' |translateTA }}" (click)="onZoomOut()">
        <nz-icon nzType="zoom-out" nzTheme="outline"></nz-icon>
      </button>
      
      <span class="zoom-indicator" nz-tooltip="{{ 'builderScreen.actions.resetZoom' |translateTA }}" (click)="onResetZoom()">
        {{ getCurrentZoom() }}%
      </span>
      
      <button nz-button nzType="text" nzSize="small" nz-tooltip="{{ 'builderScreen.actions.zoomIn' |translateTA }}" (click)="onZoomIn()">
        <nz-icon nzType="zoom-in" nzTheme="outline"></nz-icon>
      </button>
    </div>

    <!-- TEMPORARIAMENTE OCULTO - Menu Mais Opções (Importar/Exportar/Configurações/Ajuda)
    <nz-divider nzType="vertical"></nz-divider>

    <button nz-button nzType="text" nz-dropdown [nzDropdownMenu]="moreMenu" nzTrigger="click" nzPlacement="topRight" nz-tooltip="{{ 'builderScreen.actions.moreOptions' |translateTA }}">
      <nz-icon nzType="more" nzTheme="outline"></nz-icon>
    </button>
    <nz-dropdown-menu #moreMenu="nzDropdownMenu">
      <ul nz-menu>
        <li nz-menu-item (click)="onExportJson()">
          <nz-icon nzType="download" nzTheme="outline"></nz-icon>
          {{ 'builderScreen.actions.exportJson' |translateTA }}
        </li>
        <li nz-menu-item (click)="onImportJson()">
          <nz-icon nzType="upload" nzTheme="outline"></nz-icon>
          {{ 'builderScreen.actions.importJson' |translateTA }}
        </li>
        <li nz-menu-divider></li>
        <li nz-menu-item>
          <nz-icon nzType="setting" nzTheme="outline"></nz-icon>
          {{ 'builderScreen.actions.settings' |translateTA }}
        </li>
        <li nz-menu-item (click)="onShowHelp()">
          <nz-icon nzType="question-circle" nzTheme="outline"></nz-icon>
          {{ 'builderScreen.actions.help' |translateTA }}
        </li>
      </ul>
    </nz-dropdown-menu>
    -->
  </div>
</div>

<!-- Barra de Ação Móvel -->
<div class="mobile-action-bar" *ngIf="(screenSize$ | async) === 'mobile'">
  <div class="mobile-primary-actions">
    <button nz-button nzType="primary" nzBlock [nzLoading]="isSaving$ | async" (click)="onSave()">
      <nz-icon nzType="save" nzTheme="outline"></nz-icon>
      {{ 'builderScreen.actions.save' |translateTA }}
    </button>
  </div>
  
  <div class="mobile-secondary-actions">
    <button nz-button nzType="text" (click)="onCancel()">
      {{ 'builderScreen.actions.cancel' |translateTA }}
    </button>
    
    <button nz-button nzType="text" (click)="onTogglePreview()" [class.active]="isPreviewMode()">
      <nz-icon nzType="eye" nzTheme="outline"></nz-icon>
    </button>
    
    <button nz-button nzType="text" nz-dropdown [nzDropdownMenu]="mobileMenu" nzTrigger="click">
      <nz-icon nzType="more" nzTheme="outline"></nz-icon>
    </button>
    <nz-dropdown-menu #mobileMenu="nzDropdownMenu">
      <ul nz-menu>
        <li nz-menu-item (click)="onUndo()" [class.disabled]="!(canUndo$ | async)">
          <nz-icon nzType="undo" nzTheme="outline"></nz-icon>
          {{ 'builderScreen.actions.undo' |translateTA }}
        </li>
        <li nz-menu-item (click)="onRedo()" [class.disabled]="!(canRedo$ | async)">
          <nz-icon nzType="redo" nzTheme="outline"></nz-icon>
          {{ 'builderScreen.actions.redo' |translateTA }}
        </li>
        <li nz-menu-divider></li>
        <li nz-menu-item (click)="onExportJson()">
          <nz-icon nzType="download" nzTheme="outline"></nz-icon>
          {{ 'builderScreen.actions.exportJson' |translateTA }}
        </li>
        <li nz-menu-item (click)="onImportJson()">
          <nz-icon nzType="upload" nzTheme="outline"></nz-icon>
          {{ 'builderScreen.actions.importJson' |translateTA }}
        </li>
      </ul>
    </nz-dropdown-menu>
  </div>
</div>
